import { render, staticRenderFns } from "./CallLogsIndex.vue?vue&type=template&id=3d661a3b"
import script from "./CallLogsIndex.vue?vue&type=script&lang=ts"
export * from "./CallLogsIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports